import apiFetch from '../../apiFetch'

export default function (stockDossierId, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/dossierStock/${stockDossierId}/ActivateCrane`, method: 'PUT', token: token, lastAccessDate })
}
